import { z } from "zod"

export enum HourReportWorkflow {
  ReportingOnly = "reporting-only",
  Approval = "approval",
  CheckAndApproval = "check-and-approval",
}

export const HourReportSettingsSchema = z.object({
  allowAdminsToCheckAndApproveOwnHours: z.boolean(),
  approvalRequiresChecking: z.boolean().optional(),
  reviewRequiresSubmission: z.boolean().optional(),
  workflow: z.nativeEnum(HourReportWorkflow),
})

export const HourReportSettingsResponseSchema = z.object({
  hourReportSettings: HourReportSettingsSchema,
  canUpdateWorkflow: z.boolean(),
  canUpdateAdminSelfReview: z.boolean(),
})

export const makeHourReportSettingsViewModel = (response: unknown): HourReportSettingsViewModel => {
  const parsedResponse = HourReportSettingsResponseSchema.parse(response)
  return parsedResponse
}

export const canUpdateHourReportSettings = (
  settings?: Pick<HourReportSettingsViewModel, "canUpdateWorkflow" | "canUpdateAdminSelfReview">
) => Boolean(settings?.canUpdateWorkflow || settings?.canUpdateAdminSelfReview)

type HourReportSettingsResponse = z.infer<typeof HourReportSettingsResponseSchema>

export type HourReportSettingsViewModel = HourReportSettingsResponse
export type HourReportSettings = z.infer<typeof HourReportSettingsSchema>
